import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LeftSidebarMenu from "./components/Layout/LeftSidebarMenu";
import Footer from "./components/Layout/Footer";
import TopNavbar from "./components/Layout/TopNavbar";
import ScrollToTop from "./components/Layout/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";
import { AppSettingsProvider } from "./context/AppSettingsContext";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import PermissionRoute from "./components/Auth/PermissionRoute";
import Unauthorized from "./pages/Unauthorized";
import Login from "./pages/authentication/Login";
import Register from "./pages/authentication/Register";
import Home from "./pages/frontend/home/Home";
import Features from "./pages/Features";
import Team from "./pages/Team";
import VisionMission from "./pages/VisionMission";
import Leadership from "./pages/Leadership";
import Faq from "./pages/Faq";
import Contact from "./pages/frontend/contact/Contact";
import Ecommerce from "./pages/dashboard/Dashboard";
import CRM from "./pages/dashboard/CRM";
import ProjectManagement from "./pages/dashboard/ProjectManagement";
import LMS from "./pages/dashboard/LMS";
import HelpDesk from "./pages/dashboard/HelpDesk";
import Analytics from "./pages/dashboard/Analytics";
import Crypto from "./pages/dashboard/Crypto";
import Sales from "./pages/dashboard/Sales";
import Hospital from "./pages/dashboard/Hospital";
import Marketing from "./pages/dashboard/Marketing";
import NFT from "./pages/dashboard/NFT";
import Saas from "./pages/dashboard/Saas";
import RealEstate from "./pages/dashboard/RealEstate";
import Shipment from "./pages/dashboard/Shipment";
import Finance from "./pages/dashboard/Finance";
import HRM from "./pages/dashboard/HRM";
import School from "./pages/dashboard/School";
import CallCenter from "./pages/dashboard/CallCenter";
import PosSystem from "./pages/dashboard/PosSystem";
import Podcast from "./pages/dashboard/Podcast";
import SocialMedia from "./pages/dashboard/SocialMedia";
import Doctor from "./pages/dashboard/Doctor";
import BeautySalon from "./pages/dashboard/BeautySalon";
import StoreAnalytics from "./pages/dashboard/StoreAnalytics";
import Restaurant from "./pages/dashboard/Restaurant";
import ToDoList from "./pages/apps/ToDoList";
import Calendar from "./pages/apps/Calendar";
import Contacts from "./pages/apps/Contacts";
import Chat from "./pages/apps/Chat";
import Email from "./pages/apps/email/Email";
import Promotions from "./pages/apps/email/Promotions";
import Compose from "./pages/apps/email/Compose";
import Read from "./pages/apps/email/Read";
import KanbanBoard from "./pages/apps/KanbanBoard";
import FileManager from "./pages/apps/FileManager";
import Assets from "./pages/apps/FileManager/Assets";
import Projects from "./pages/apps/FileManager/Projects";
import Personal from "./pages/apps/FileManager/Personal";
import Applications from "./pages/apps/FileManager/Applications";
import Documents from "./pages/apps/FileManager/Documents";
import Media from "./pages/apps/FileManager/Media";
import Recents from "./pages/apps/FileManager/Recents";
import Important from "./pages/apps/FileManager/Important";
import ProductsGrid from "./pages/ecommerce/ProductsGrid";
import Published from "./pages/dashboard/ProductsList/Published";
import Draft from "./pages/dashboard/ProductsList/Draft";
import ProductsDetails from "./pages/dashboard/ProductsList/ProductsDetails";
import CreateProduct from "./pages/ecommerce/CreateProduct";
import EditProduct from "./pages/dashboard/ProductsList/Edit";
import Cart from "./pages/ecommerce/Cart";
import Checkout from "./pages/ecommerce/Checkout";
import Orders from "./pages/ecommerce/Orders";
import OrderDetails from "./pages/ecommerce/Orders/OrderDetails";
import CreateOrder from "./pages/ecommerce/Orders/CreateOrder";
import Tracking from "./pages/ecommerce/Orders/Tracking";
import Customers from "./pages/ecommerce/Customers";
import CustomersDetails from "./pages/ecommerce/Customers/CustomersDetails";
import Categories from "./pages/ecommerce/Categories";
import Sellers from "./pages/ecommerce/Sellers";
import SellersDetails from "./pages/ecommerce/Sellers/SellersDetails";
import CreateSeller from "./pages/ecommerce/Sellers/CreateSeller";
import Reviews from "./pages/ecommerce/Reviews";
import Refunds from "./pages/ecommerce/Refunds";
import CrmContacts from "./pages/crm/CrmContacts";
import CrmCustomers from "./pages/crm/CrmCustomers";
import CrmLeads from "./pages/crm/CrmLeads";
import CrmDeals from "./pages/crm/CrmDeals";
import ProjectOverview from "./pages/project-management/ProjectOverview";
import ProjectsList from "./pages/project-management/ProjectsList";
import CreateProject from "./pages/project-management/CreateProject";
import Clients from "./pages/project-management/Clients";
import Teams from "./pages/project-management/Teams";
import PmKanbanBoard from "./pages/project-management/PmKanbanBoard";
import PmUsers from "./pages/project-management/PmUsers";
import Courses from "./pages/lms/Courses";
import CoursesDetails from "./pages/lms/CoursesDetails";
import LessonPreview from "./pages/lms/LessonPreview";
import CreateCourse from "./pages/lms/CreateCourse";
import EditCourse from "./pages/lms/EditCourse";
import Instructors from "./pages/lms/Instructors";
import Tickets from "./pages/helpdesk/Tickets";
import TicketsDetails from "./pages/helpdesk/Tickets/TicketsDetails";
import Agents from "./pages/helpdesk/Agents";
import Reports from "./pages/helpdesk/Reports";
import Marketplace from "./pages/nft/Marketplace";
import ExploreAll from "./pages/nft/ExploreAll";
import LiveAuction from "./pages/nft/LiveAuction";
import NftDetails from "./pages/nft/NftDetails";
import NftCreators from "./pages/nft/NftCreators";
import NftCreatorDetails from "./pages/nft/NftCreatorDetails";
import WalletConnect from "./pages/nft/WalletConnect";
import CreateNft from "./pages/nft/CreateNft";
import PropertyList from "./pages/real-estate/PropertyList";
import PropertyDetails from "./pages/real-estate/PropertyDetails";
import AddProperty from "./pages/real-estate/AddProperty";
import ReAgents from "./pages/real-estate/ReAgents";
import ReAgentsDetails from "./pages/real-estate/ReAgentsDetails";
import AddAgents from "./pages/real-estate/AddAgents";
import ReCustomers from "./pages/real-estate/ReCustomers";
import Wallet from "./pages/finance/Wallet";
import Transactions from "./pages/finance/Transactions";
import PatientsList from "./pages/doctor/PatientsList";
import AddPatient from "./pages/doctor/AddPatient";
import PatientDetails from "./pages/doctor/PatientDetails";
import Appointments from "./pages/doctor/Appointments";
import Prescriptions from "./pages/doctor/Prescriptions";
import WritePrescription from "./pages/doctor/WritePrescription";
import Menus from "./pages/restaurant/Menus";
import DishDetails from "./pages/restaurant/DishDetails";
import Events from "./pages/events";
import EventsList from "./pages/events/EventsList";
import EventsDetails from "./pages/events/EventsDetails";
import CreateAnEvent from "./pages/events/CreateAnEvent";
import EditAnEvent from "./pages/events/EditAnEvent";
import SProfile from "./pages/social/SProfile";
import SAbout from "./pages/social/SAbout";
import SActivity from "./pages/social/SActivity";
import SosialProfileSettings from "./pages/social/SosialProfileSettings";
import Invoices from "./pages/invoices";
import InvoicesDetails from "./pages/invoices/InvoicesDetails";
import CreateInvoice from "./pages/invoices/CreateInvoice";
import EditInvoice from "./pages/invoices/EditInvoice";
import Users from "./pages/users";
import UsersList from "./pages/users/UsersList";
import AddUsers from "./pages/users/AddUsers";
import UserProfile from "./pages/profile/UserProfile";
import TeamsProfile from "./pages/profile/TeamsProfile";
import MyProjects from "./pages/profile/MyProjects";
import Starter from "./pages/Starter";
import MaterialSymbols from "./pages/icons/MaterialSymbols";
import Remixicon from "./pages/icons/Remixicon";
import Autocomplete from "./pages/ui-kit/Autocomplete";
import Buttons from "./pages/ui-kit/Buttons";
import Checkbox from "./pages/ui-kit/Checkbox";
import Radio from "./pages/ui-kit/Radio";
import Rating from "./pages/ui-kit/Rating";
import Select from "./pages/ui-kit/Select";
import Slider from "./pages/ui-kit/Slider";
import Switch from "./pages/ui-kit/Switch";
import TransferList from "./pages/ui-kit/TransferList";
import Avatar from "./pages/ui-kit/Avatar";
import Badge from "./pages/ui-kit/Badge";
import Chip from "./pages/ui-kit/Chip";
import Divider from "./pages/ui-kit/Divider";
import Table from "./pages/ui-kit/Table";
import Tooltip from "./pages/ui-kit/Tooltip";
import Typography from "./pages/ui-kit/Typography";
import Alerts from "./pages/ui-kit/Alerts";
import Dialog from "./pages/ui-kit/Dialog";
import Progress from "./pages/ui-kit/Progress";
import Snackbar from "./pages/ui-kit/Snackbar";
import Accordion from "./pages/ui-kit/Accordion";
import Card from "./pages/ui-kit/Card";
import Breadcrumbs from "./pages/ui-kit/Breadcrumbs";
import Pagination from "./pages/ui-kit/Pagination";
import SpeedDial from "./pages/ui-kit/SpeedDial";
import Stepper from "./pages/ui-kit/Stepper";
import Tabs from "./pages/ui-kit/Tabs";
import ImageList from "./pages/ui-kit/ImageList";
import Transitions from "./pages/ui-kit/Transitions";
import TreeView from "./pages/ui-kit/TreeView";
import Masonry from "./pages/ui-kit/Masonry";
import UITimeline from "./pages/ui-kit/UITimeline";
import BasicTables from "./pages/tables/BasicTables";
import DataTables from "./pages/tables/DataTables";
import BasicElements from "./pages/forms/BasicElements";
import AdvancedElements from "./pages/forms/AdvancedElements";
import Editors from "./pages/forms/Editors";
import FileUploader from "./pages/forms/FileUploader";
import Line from "./pages/charts/Line";
import Area from "./pages/charts/Area";
import Column from "./pages/charts/Column";
import Mixed from "./pages/charts/Mixed";
import Radialbar from "./pages/charts/Radialbar";
import Radar from "./pages/charts/Radar";
import Pie from "./pages/charts/Pie";
import Polar from "./pages/charts/Polar";
import More from "./pages/charts/More";
import SignIn from "./pages/authentication/SignIn";
import SignUp from "./pages/authentication/SignUp";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import ResetPassword from "./pages/authentication/ResetPassword";
import ConfirmEmail from "./pages/authentication/ConfirmEmail";
import LockScreen from "./pages/authentication/LockScreen";
import Logout from "./pages/authentication/Logout";
import Pricing from "./pages/Pricing";
import Timeline from "./pages/Timeline";
import ExtraFaq from "./pages/ExtraFaq";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import Search from "./pages/Search";
import ComingSoon from "./pages/ComingSoon";
import BlankPage from "./pages/BlankPage";
import NotFound from "./pages/NotFound";
import InternalError from "./pages/InternalError";
import Widgets from "./pages/Widgets";
import Maps from "./pages/Maps";
import Notifications from "./pages/Notifications";
import Members from "./pages/Members";
import MyProfile from "./pages/MyProfile";
import AccountSettings from "./pages/settings/AccountSettings";
import ChangePassword from "./pages/settings/ChangePassword";
import Connections from "./pages/settings/Connections";
import PrivacyPolicy from "./pages/settings/PrivacyPolicy";
import TermsConditions from "./pages/settings/TermsConditions";
import PermissionsList from "./components/Dashboard/UserManagment/Permissions";
import Roles from "./components/Dashboard/UserManagment/Roles/RoleList";
import CreateRole from "./components/Dashboard/UserManagment/Roles/CreateRole";
import EditRole from "./components/Dashboard/UserManagment/Roles/EditRole";
import AddUser from "./components/Dashboard/UserManagment/Users/AddUser";
import UserList from "./components/Dashboard/UserManagment/Users/UsersList";
import EditUser from "./components/Dashboard/UserManagment/Users/UserEdit";
import ResetUserPassword from "./components/Dashboard/UserManagment/Users/ResetPassword";
import ApplicationTypeList from "./components/Dashboard/ApplicationSettings/Type/ApplicationTypeList";
import AddApplicationType from "./components/Dashboard/ApplicationSettings/Type/AddApplicationType";
import EditApplicationType from "./components/Dashboard/ApplicationSettings/Type/EditApplicationType";
import AddApplicationSettings from "./components/Dashboard/ApplicationSettings/Settings/AddApplicationSettings";
import EditApplicationSettings from "./components/Dashboard/ApplicationSettings/Settings/EditApplicationSettings";
import ApplicationSettingsList from "./components/Dashboard/ApplicationSettings/Settings/ApplicationSettingsList";
import ApplicationSettings from "./components/Dashboard/ApplicationSettings/ApplicationSetting";
import ThemeSettings from "./components/Dashboard/ThemeSettings";
import RegionsList from "./pages/dashboard/RegionsList";
import CreateRegion from "./pages/dashboard/RegionsList/Create";
import RegionDetails from "./pages/dashboard/RegionsList/Show";
import EditRegion from "./pages/dashboard/RegionsList/Edit";
import PaymentTermsList from "./pages/dashboard/PaymentTerms/index";
import CreatePaymentTerm from "./pages/dashboard/PaymentTerms/Create";
import PaymentTermDetails from "./pages/dashboard/PaymentTerms/Show";
import EditPaymentTerm from "./pages/dashboard/PaymentTerms/Edit";
import UserTypesList from "./pages/dashboard/UserTypesList";
import CreateUserType from "./pages/dashboard/UserTypesList/Create";
import UserTypeDetails from "./pages/dashboard/UserTypesList/Show";
import EditUserType from "./pages/dashboard/UserTypesList/Edit";
import CreateBrandForm from "./pages/dashboard/BrandsList/CreateBrandform";
import ProductTypesList from "./pages/dashboard/ProductTypesList";
import CreateProductType from "./pages/dashboard/ProductTypesList/Create";
import ProductTypeDetails from "./pages/dashboard/ProductTypesList/Show";
import EditProductType from "./pages/dashboard/ProductTypesList/Edit";
import CategoriesList from "./pages/dashboard/Categories";
import CreateCategories from "./pages/dashboard/Categories/Create";
import CategoriesDetails from "./pages/dashboard/Categories/show";
import EditCategories from "./pages/dashboard/Categories/Edit";
import BrandsList from "./pages/dashboard/BrandsList";
import BrandDetails from "./pages/dashboard/BrandsList/Show";
import EditBrand from "./pages/dashboard/BrandsList/Edit";
import EditRegionForm from "./components/Dashboard/RegionsListContent/Edit";
import ProductsList from "./pages/dashboard/ProductsList";
import CreateProductForm from "./pages/dashboard/ProductsList/CreateProductForm";
import ProductDetails from "./pages/dashboard/ProductsList/Show";
import AppUsersList from "./pages/dashboard/AppUsersList";
import CreateAppUser from "./pages/dashboard/AppUsersList/Create";
import AppUserDetails from "./pages/dashboard/AppUsersList/Show";
import EditAppUser from "./pages/dashboard/AppUsersList/Edit";
import DeliveryTermsList from "./pages/dashboard/DeliveryTerms/index";
import CreateDeliveryTerm from "./pages/dashboard/DeliveryTerms/Create";
import DeliveryTermDetails from "./pages/dashboard/DeliveryTerms/Show";
import EditDeliveryTerm from "./pages/dashboard/DeliveryTerms/Edit";
import CustomerOrdersList from "./pages/dashboard/CustomerOrdersList";
import CreateCustomerOrder from "./pages/dashboard/CustomerOrdersList/Create";
import CustomerOrderDetails from "./pages/dashboard/CustomerOrdersList/Show";
import EditCustomerOrder from "./pages/dashboard/CustomerOrdersList/Edit";
import DealerQuotations from "./pages/dashboard/Dealerquotations";
import CreateDealerQuotation from "./pages/dashboard/Dealerquotations/create";
import DealerQuotationDetails from "./components/Dashboard/DealerQuotationscontent/view";
import EditDealerQuotation from "./pages/dashboard/Dealerquotations/EditDealerQuotation";
import AppUserReport from "./components/AppUserReport";
import About from "./pages/frontend/about/About";
import CustomerOrderReport from "./components/CustomerOrderReport";
import DealerQuotationReport from "./components/DealerQuotationsReport";
import EnquiryNow from "./pages/frontend/enquirynow/EnquiryNow";
import EnquirySuccess from "./pages/frontend/enquirysuccess/EnquirySuccess";
import { useLocation } from "react-router-dom";
import FrontendPrivacyPolicy from "./pages/frontend/PrivacyPolicy";
import FrontendTermsAndConditions from "./pages/frontend/TermsAndConditions";
import FrontendDeleteAccount from "./pages/frontend/DeleteAccount";

// Authenticated layout component
const AuthenticatedLayout = ({ children, toggleActive, active, title }) => (
  <>
    <TopNavbar toggleActive={toggleActive} title={title} />
    <LeftSidebarMenu toggleActive={toggleActive} />
    <div className="main-content" style={{ marginBottom: "150px" }}>
      {children}
      <Footer />
    </div>
  </>
);

// Create a new component that uses useLocation
const AppContent = () => {
  const [active, setActive] = useState(false);
  const [pathname, setPathname] = useState("");
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    setPathname(window.location.pathname);
  }, []);

  const toggleActive = () => {
    setActive(!active);
  };

  const isFrontendRoute =
    pathname === "/" ||
    pathname === "/about" ||
    pathname === "/contact" ||
    pathname === "/enquiry";
  const hideWrapperRoutes = [
    "/",
    "/login",
    "/about",
    "/contact",
    "/enquiry",
    "/enquiry-success",
    "/privacy-policy",
    "/privacy",
    "/terms-and-conditions",
    "/delete-account",
  ];
  const shouldHideWrapper = hideWrapperRoutes.includes(path);

  return (
    <div
      className={`
      ${!shouldHideWrapper ? "main-wrapper-content" : ""} 
      ${active && !shouldHideWrapper ? "active" : ""} 
      ${isFrontendRoute ? "frontend-layout" : ""}
    `}
    >
      <AuthProvider>
        <AppSettingsProvider>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/enquiry" element={<EnquiryNow />} />
            <Route path="/enquiry-success" element={<EnquirySuccess />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<FrontendPrivacyPolicy />} />
            <Route path="/privacy" element={<FrontendPrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<FrontendTermsAndConditions />} />
            <Route path="/delete-account" element={<FrontendDeleteAccount />} />

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/authentication/sign-up" element={<SignUp />} />
            <Route
              path="/authentication/forgot-password"
              element={<ForgotPassword />}
            />
            <Route
              path="/authentication/reset-password"
              element={<ResetPassword />}
            />
            <Route
              path="/authentication/confirm-email"
              element={<ConfirmEmail />}
            />
            <Route
              path="/authentication/lock-screen"
              element={<LockScreen />}
            />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/features" element={<Features />} />
            <Route path="/team" element={<Team />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Dashboard"
                        >
                          <Ecommerce />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="crm"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="CRM Dashboard"
                        >
                          <CRM />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="project-management"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Project Management Dashboard"
                        >
                          <ProjectManagement />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="lms"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="LMS Dashboard"
                        >
                          <LMS />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="helpdesk"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Help Desk Dashboard"
                        >
                          <HelpDesk />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="analytics"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Analytics Dashboard"
                        >
                          <Analytics />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="crypto"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Crypto Dashboard"
                        >
                          <Crypto />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="sales"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Sales Dashboard"
                        >
                          <Sales />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="hospital"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Hospital Dashboard"
                        >
                          <Hospital />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="marketing"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Marketing Dashboard"
                        >
                          <Marketing />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="nft"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="NFT Dashboard"
                        >
                          <NFT />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="saas"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="SaaS Dashboard"
                        >
                          <Saas />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="real-estate"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Real Estate Dashboard"
                        >
                          <RealEstate />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="shipment"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Shipment Dashboard"
                        >
                          <Shipment />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="finance"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Finance Dashboard"
                        >
                          <Finance />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="hrm"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="HRM Dashboard"
                        >
                          <HRM />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="school"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="School Dashboard"
                        >
                          <School />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="call-center"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Call Center Dashboard"
                        >
                          <CallCenter />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="pos-system"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="POS System Dashboard"
                        >
                          <PosSystem />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="podcast"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Podcast Dashboard"
                        >
                          <Podcast />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="social-media"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Social Media Dashboard"
                        >
                          <SocialMedia />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="doctor"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Doctor Dashboard"
                        >
                          <Doctor />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="beauty-salon"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Beauty Salon Dashboard"
                        >
                          <BeautySalon />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="store-analytics"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Store Analytics Dashboard"
                        >
                          <StoreAnalytics />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="restaurant"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Restaurant Dashboard"
                        >
                          <Restaurant />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/apps/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="to-do-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="To-Do List"
                        >
                          <ToDoList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="calendar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Calendar"
                        >
                          <Calendar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="contacts"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Contacts"
                        >
                          <Contacts />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="chat"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Chat"
                        >
                          <Chat />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="email"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Email"
                        >
                          <Email />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="email/promotions"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Promotions"
                        >
                          <Promotions />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="email/compose"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Compose Email"
                        >
                          <Compose />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="email/read"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Read Email"
                        >
                          <Read />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="kanban-board"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Kanban Board"
                        >
                          <KanbanBoard />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="File Manager"
                        >
                          <FileManager />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/assets"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Assets"
                        >
                          <Assets />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/projects"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Projects"
                        >
                          <Projects />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/personal"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Personal Files"
                        >
                          <Personal />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/applications"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Applications"
                        >
                          <Applications />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/documents"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Documents"
                        >
                          <Documents />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/media"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Media"
                        >
                          <Media />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/recents"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Recent Files"
                        >
                          <Recents />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-manager/important"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Important Files"
                        >
                          <Important />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/ecommerce/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="products-grid"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Products Grid"
                        >
                          <ProductsGrid />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="products-list/published"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Published Products"
                        >
                          <Published />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="products-list/draft"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Draft Products"
                        >
                          <Draft />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="products-list/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Products Details"
                        >
                          <ProductsDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-region"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Region"
                        >
                          <CreateRegion />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-brand"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Brand"
                        >
                          <CreateBrandForm />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="regions-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Region Details"
                        >
                          <RegionDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="brands-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Brand Details"
                        >
                          <BrandDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-region/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Region"
                        >
                          <EditRegion />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-brand/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Brand"
                        >
                          <EditBrand />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="payment-terms-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Payment Terms List"
                        >
                          <PaymentTermsList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-payment-term"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Payment Term"
                        >
                          <CreatePaymentTerm />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="payment-terms-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Payment Term Details"
                        >
                          <PaymentTermDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-payment-term/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Payment Term"
                        >
                          <EditPaymentTerm />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="delivery-terms-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Delivery Terms List"
                        >
                          <DeliveryTermsList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-delivery-term"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Delivery Term"
                        >
                          <CreateDeliveryTerm />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="delivery-terms-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Delivery Term Details"
                        >
                          <DeliveryTermDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-delivery-term/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Delivery Term"
                        >
                          <EditDeliveryTerm />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-dealer-quotation"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Quotation"
                        >
                          <CreateDealerQuotation />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="dealerquotations/view/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Quotation Details"
                        >
                          <DealerQuotationDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-dealer-quotation/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Quotation"
                        >
                          <EditDealerQuotation />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="user-types"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="User Types List"
                        >
                          <UserTypesList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-userTypes"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create User Type"
                        >
                          <CreateUserType />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="userTypes-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="User Type Details"
                        >
                          <UserTypeDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-userTypes/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit User Type"
                        >
                          <EditUserType />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="product-types"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Product Types List"
                        >
                          <ProductTypesList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-productTypes"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Product Type"
                        >
                          <CreateProductType />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="productTypes-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Product Type Details"
                        >
                          <ProductTypeDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-productTypes/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Product Type"
                        >
                          <EditProductType />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="categories"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Categories List"
                        >
                          <CategoriesList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-categories"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Category"
                        >
                          <CreateCategories />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="categories-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Category Details"
                        >
                          <CategoriesDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-categories/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Category"
                        >
                          <EditCategories />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="app-users"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Users List"
                        >
                          <AppUsersList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-appUsers"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create User"
                        >
                          <CreateAppUser />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="appUsers-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="User Details"
                        >
                          <AppUserDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-appUsers/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit User"
                        >
                          <EditAppUser />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customer-orders"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Customer Orders List"
                        >
                          <CustomerOrdersList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-customerOrders"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Enquiry"
                        >
                          <CreateCustomerOrder />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customerOrders-list/details/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Enquiry Details"
                        >
                          <CustomerOrderDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-customerOrders/:id"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Enquiry"
                        >
                          <EditCustomerOrder />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="cart"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Cart"
                        >
                          <Cart />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="checkout"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Checkout"
                        >
                          <Checkout />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="orders"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Orders"
                        >
                          <Orders />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="orders/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Order Details"
                        >
                          <OrderDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="orders/create"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Order"
                        >
                          <CreateOrder />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="orders/tracking"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Order Tracking"
                        >
                          <Tracking />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customers"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Customers"
                        >
                          <Customers />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customers/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Customer Details"
                        >
                          <CustomersDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="categories"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Categories"
                        >
                          <Categories />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="sellers"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Sellers"
                        >
                          <Sellers />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="sellers/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Seller Details"
                        >
                          <SellersDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="sellers/create"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Seller"
                        >
                          <CreateSeller />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="reviews"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Reviews"
                        >
                          <Reviews />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="refunds"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Refunds"
                        >
                          <Refunds />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/crm/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="contacts"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="CRM Contacts"
                        >
                          <CrmContacts />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customers"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="CRM Customers"
                        >
                          <CrmCustomers />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="leads"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="CRM Leads"
                        >
                          <CrmLeads />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="deals"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="CRM Deals"
                        >
                          <CrmDeals />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/project-management/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="project-overview"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Project Overview"
                        >
                          <ProjectOverview />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="projects-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Projects List"
                        >
                          <ProjectsList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-project"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Project"
                        >
                          <CreateProject />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="clients"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Clients"
                        >
                          <Clients />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="teams"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Teams"
                        >
                          <Teams />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="kanban-board"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Project Management Kanban Board"
                        >
                          <PmKanbanBoard />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="users"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Project Management Users"
                        >
                          <PmUsers />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/lms/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="courses"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Courses"
                        >
                          <Courses />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="courses/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Course Details"
                        >
                          <CoursesDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="courses/lesson-preview"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Lesson Preview"
                        >
                          <LessonPreview />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-course"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Course"
                        >
                          <CreateCourse />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-course"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Course"
                        >
                          <EditCourse />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="instructors"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Instructors"
                        >
                          <Instructors />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/helpdesk/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="tickets"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Tickets"
                        >
                          <Tickets />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="tickets/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Ticket Details"
                        >
                          <TicketsDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="agents"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Agents"
                        >
                          <Agents />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="reports"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Helpdesk Reports"
                        >
                          <Reports />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/nft/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="marketplace"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="NFT Marketplace"
                        >
                          <Marketplace />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="explore-all"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Explore All NFTs"
                        >
                          <ExploreAll />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="live-auction"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Live Auction"
                        >
                          <LiveAuction />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="NFT Details"
                        >
                          <NftDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="creators"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="NFT Creators"
                        >
                          <NftCreators />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="creators/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="NFT Creator Details"
                        >
                          <NftCreatorDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="wallet-connect"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Wallet Connect"
                        >
                          <WalletConnect />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create NFT"
                        >
                          <CreateNft />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/real-estate/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="property-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Property List"
                        >
                          <PropertyList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="property-details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Property Details"
                        >
                          <PropertyDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="add-property"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Add Property"
                        >
                          <AddProperty />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="agents"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Real Estate Agents"
                        >
                          <ReAgents />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="agents/details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Agent Details"
                        >
                          <ReAgentsDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="agents/add"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Add Agent"
                        >
                          <AddAgents />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="customers"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Real Estate Customers"
                        >
                          <ReCustomers />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/finance/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="wallet"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Wallet"
                        >
                          <Wallet />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="transactions"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Transactions"
                        >
                          <Transactions />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/doctor/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="patients-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Patients List"
                        >
                          <PatientsList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="add-patient"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Add Patient"
                        >
                          <AddPatient />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="patient-details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Patient Details"
                        >
                          <PatientDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="appointments"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Appointments"
                        >
                          <Appointments />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="prescriptions"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Prescriptions"
                        >
                          <Prescriptions />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="write-prescription"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Write Prescription"
                        >
                          <WritePrescription />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/restaurant/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="menus"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Menus"
                        >
                          <Menus />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="dish-details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Dish Details"
                        >
                          <DishDetails />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/events/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Events"
                        >
                          <Events />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="events-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Events List"
                        >
                          <EventsList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="events-details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Event Details"
                        >
                          <EventsDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-an-event"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Event"
                        >
                          <CreateAnEvent />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-an-event"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Event"
                        >
                          <EditAnEvent />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/social/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="profile"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Social Profile"
                        >
                          <SProfile />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="about"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="About"
                        >
                          <SAbout />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="activity"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Activity"
                        >
                          <SActivity />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="settings"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Social Profile Settings"
                        >
                          <SosialProfileSettings />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/invoices/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Invoices"
                        >
                          <Invoices />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="invoices-details"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Invoice Details"
                        >
                          <InvoicesDetails />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="create-invoice"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Create Invoice"
                        >
                          <CreateInvoice />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="edit-invoice"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Edit Invoice"
                        >
                          <EditInvoice />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/users/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Users"
                        >
                          <Users />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="users-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Users List"
                        >
                          <UsersList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="add-user"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Add User"
                        >
                          <AddUsers />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="User Profile"
                        >
                          <UserProfile />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="teams"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Teams Profile"
                        >
                          <TeamsProfile />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="projects"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="My Projects"
                        >
                          <MyProjects />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/icons/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="material-symbols"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Material Symbols"
                        >
                          <MaterialSymbols />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="remixicon"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Remixicon"
                        >
                          <Remixicon />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/ui-kit/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="autocomplete"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Autocomplete"
                        >
                          <Autocomplete />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="buttons"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Buttons"
                        >
                          <Buttons />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="checkbox"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Checkbox"
                        >
                          <Checkbox />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="radio"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Radio"
                        >
                          <Radio />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="rating"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Rating"
                        >
                          <Rating />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="select"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Select"
                        >
                          <Select />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="slider"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Slider"
                        >
                          <Slider />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="switch"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Switch"
                        >
                          <Switch />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="transfer-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Transfer List"
                        >
                          <TransferList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="avatar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Avatar"
                        >
                          <Avatar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="badge"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Badge"
                        >
                          <Badge />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="chip"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Chip"
                        >
                          <Chip />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="divider"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Divider"
                        >
                          <Divider />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="table"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Table"
                        >
                          <Table />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="tooltip"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Tooltip"
                        >
                          <Tooltip />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="typography"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Typography"
                        >
                          <Typography />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="alerts"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Alerts"
                        >
                          <Alerts />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="dialog"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Dialog"
                        >
                          <Dialog />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="progress"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Progress"
                        >
                          <Progress />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="snackbar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Snackbar"
                        >
                          <Snackbar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="accordion"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Accordion"
                        >
                          <Accordion />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="card"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Card"
                        >
                          <Card />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="breadcrumbs"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Breadcrumbs"
                        >
                          <Breadcrumbs />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="pagination"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Pagination"
                        >
                          <Pagination />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="speed-dial"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Speed Dial"
                        >
                          <SpeedDial />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="stepper"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Stepper"
                        >
                          <Stepper />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="tabs"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Tabs"
                        >
                          <Tabs />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="image-list"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Image List"
                        >
                          <ImageList />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="transitions"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Transitions"
                        >
                          <Transitions />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="tree-view"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Tree View"
                        >
                          <TreeView />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="masonry"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Masonry"
                        >
                          <Masonry />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="timeline"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="UI Timeline"
                        >
                          <UITimeline />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/tables/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="basic-table"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Basic Tables"
                        >
                          <BasicTables />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="data-table"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Data Tables"
                        >
                          <DataTables />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/forms/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="basic-elements"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Basic Elements"
                        >
                          <BasicElements />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="advanced-elements"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Advanced Elements"
                        >
                          <AdvancedElements />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="editors"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Editors"
                        >
                          <Editors />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="file-uploader"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="File Uploader"
                        >
                          <FileUploader />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/charts/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="line"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Line Chart"
                        >
                          <Line />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="area"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Area Chart"
                        >
                          <Area />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="column"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Column Chart"
                        >
                          <Column />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="mixed"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Mixed Chart"
                        >
                          <Mixed />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="radialbar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Radialbar Chart"
                        >
                          <Radialbar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="radar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Radar Chart"
                        >
                          <Radar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="pie"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Pie Chart"
                        >
                          <Pie />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="polar"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Polar Chart"
                        >
                          <Polar />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="more"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="More Charts"
                        >
                          <More />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route
                      path="account-settings"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Account Settings"
                        >
                          <AccountSettings />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="change-password"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Change Password"
                        >
                          <ChangePassword />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="connections"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Connections"
                        >
                          <Connections />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="privacy-policy"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Privacy Policy"
                        >
                          <PrivacyPolicy />
                        </AuthenticatedLayout>
                      }
                    />
                    <Route
                      path="terms-conditions"
                      element={
                        <AuthenticatedLayout
                          toggleActive={toggleActive}
                          active={active}
                          title="Terms & Conditions"
                        >
                          <TermsConditions />
                        </AuthenticatedLayout>
                      }
                    />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/starter"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Starter"
                  >
                    <Starter />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Pricing"
                  >
                    <Pricing />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/timeline"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Timeline"
                  >
                    <Timeline />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/extra-faq"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Extra FAQ"
                  >
                    <ExtraFaq />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/gallery"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Gallery"
                  >
                    <Gallery />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/testimonials"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Testimonials"
                  >
                    <Testimonials />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Search"
                  >
                    <Search />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/blank-page"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Blank Page"
                  >
                    <BlankPage />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/not-found"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Not Found"
                  >
                    <NotFound />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/internal-error"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Internal Error"
                  >
                    <InternalError />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/widgets"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Widgets"
                  >
                    <Widgets />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/maps"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Maps"
                  >
                    <Maps />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Notifications"
                  >
                    <Notifications />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/members"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Members"
                  >
                    <Members />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/my-profile"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="My Profile"
                  >
                    <MyProfile />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/logout"
              element={
                <ProtectedRoute>
                  <Logout />
                </ProtectedRoute>
              }
            />

            <Route
              path="/unauthorized"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Unauthorized"
                  >
                    <Unauthorized />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/permissions"
              element={
                <PermissionRoute
                  anyOf={["view-permissions", "add-permissions", "edit-permissions", "delete-permissions"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Permissions"
                  >
                    <PermissionsList />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/roles"
              element={
                <PermissionRoute
                  anyOf={["view-roles", "add-roles", "edit-roles", "delete-roles"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Roles"
                  >
                    <Roles />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/roles/create"
              element={
                <PermissionRoute
                  anyOf={["add-roles"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Create Role"
                  >
                    <CreateRole />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/roles/edit/:id"
              element={
                <PermissionRoute
                  anyOf={["edit-roles"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Edit Role"
                  >
                    <EditRole />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/users"
              element={
                <PermissionRoute
                  anyOf={["view-users", "add-users", "edit-users", "delete-users"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Users"
                  >
                    <UserList />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/users/create"
              element={
                <PermissionRoute
                  anyOf={["add-users"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Create User"
                  >
                    <AddUser />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/users/edit/:userId"
              element={
                <PermissionRoute
                  anyOf={["edit-users"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Edit User"
                  >
                    <EditUser />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/users/reset/:userId"
              element={
                <PermissionRoute
                  anyOf={["edit-users"]}
                >
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Reset User Password"
                  >
                    <ResetUserPassword />
                  </AuthenticatedLayout>
                </PermissionRoute>
              }
            />

            <Route
              path="/application-setting-types"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Application Setting Types"
                  >
                    <ApplicationTypeList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-setting-types/create"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Create Application Setting Type"
                  >
                    <AddApplicationType />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-setting-types/edit/:id"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Edit Application Setting Type"
                  >
                    <EditApplicationType />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-settings"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Application Settings"
                  >
                    <ApplicationSettingsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-settings/create"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Create Application Setting"
                  >
                    <AddApplicationSettings />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-settings/edit/:id"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Edit Application Setting"
                  >
                    <EditApplicationSettings />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/application-settings/type/:slug"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Application Settings by Type"
                  >
                    <ApplicationSettings />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/regions"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Regions List"
                  >
                    <RegionsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/payment-terms"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Payment Terms List"
                  >
                    <PaymentTermsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/delivery-terms"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Delivery Terms List"
                  >
                    <DeliveryTermsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-types"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="User Types List"
                  >
                    <UserTypesList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/product-types"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Product Types List"
                  >
                    <ProductTypesList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/categories"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Categories List"
                  >
                    <CategoriesList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/brands"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Brands List"
                  >
                    <BrandsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/customer-orders"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Enquiries List"
                  >
                    <CustomerOrdersList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/dealer-quotations"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Quotations List"
                  >
                    <DealerQuotations />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-users"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Users List"
                  >
                    <AppUsersList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/theme-settings"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Theme Settings"
                  >
                    <ThemeSettings />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app-user-report"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="User Report"
                  >
                    <AppUserReport />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-order-report"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Enquiry Report"
                  >
                    <CustomerOrderReport />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/dealer-quotation-report"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Quotation Report"
                  >
                    <DealerQuotationReport />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/products-list"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Products List"
                  >
                    <ProductsList />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="edit-product/:id"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Edit Product"
                  >
                    <EditProduct />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="products-list/details/:id"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Product Details"
                  >
                    <ProductDetails />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="create-product"
              element={
                <ProtectedRoute>
                  <AuthenticatedLayout
                    toggleActive={toggleActive}
                    active={active}
                    title="Create Product"
                  >
                    <CreateProduct />
                  </AuthenticatedLayout>
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppSettingsProvider>
      </AuthProvider>
    </div>
  );
};

// Main App component
const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
